import { useMutation } from '@tanstack/react-query'
import type { IForgotPasswordRequest } from '~/@api/generated-api-types-user/Api'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

export type ForgotPasswordRequest = IForgotPasswordRequest

function useForgotPassword() {
  const client = useApiClientUser()

  const forgotPasswordMutation = useMutation({
    mutationFn: async (props: ForgotPasswordRequest) => {
      return await client.user
        .authControllerForgotPassword(props)
        .then(({ data }) => data)
    },
  })

  return {
    sendForgotPasswordEmail: forgotPasswordMutation.mutate,
    isRequesting: forgotPasswordMutation.isPending,
    error: getApiErrorMessage(
      forgotPasswordMutation.error,
      'E-mail sa nepodarilo odoslať.'
    ),
  }
}

export { useForgotPassword }
